import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  getLatestQuarterPriceInformationData,
  getPageViewId,
  getRealEstateType,
} from '../../selectors/selectors';
import styles from './IBWConversion.less';
import { navigateTo, TAB } from '../Navigation/Menu/menuConfig';
import tracking from '../../tracking/tracking';
import { RLE_BANNER_CLICK_COMPLETE_DATA } from '../../tracking/trackingNaming';

const IBWConversion = ({
  quarterPriceInformation,
  realEstateType,
  pageTitle,
  reportData,
}) => {
  const navigate = useNavigate();
  const priceFormat = new Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  const prices = [
    quarterPriceInformation[realEstateType].leastExpensive,
    quarterPriceInformation[realEstateType].mostExpensive,
  ];

  const buttonOnClick = () => {
    navigateTo(navigate, TAB.priceCheck);
    reportData({
      pageTitle,
      label: RLE_BANNER_CLICK_COMPLETE_DATA,
    });
  };

  return (
    <div className={styles.ibwConversionContainer}>
      <div className="grid grid-flex gutter-l grid-fill-rows">
        <div className="grid-item one-half palm-one-whole">
          <div className={styles.price}>
            {prices.map((price) => priceFormat.format(price)).join(' - ')}
            {' '}€/m²
          </div>
          <div className={styles.ibwConversionText}>
            Angaben zur Immobilie ergänzen um präzisen Wert zu erhalten
          </div>
        </div>
        <div className="grid-item grid-item-fixed-width palm-one-whole grid-align-end">
          <button type="button" className="button-primary palm-one-whole" onClick={buttonOnClick}>
            Immobilienwert berechnen
          </button>
        </div>
      </div>
    </div>
  );
};

IBWConversion.propTypes = {
  quarterPriceInformation: PropTypes.object.isRequired,
  realEstateType: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  reportData: PropTypes.func,
};

const mapStateToProps = (state) => ({
  quarterPriceInformation: getLatestQuarterPriceInformationData(state),
  realEstateType: getRealEstateType(state),
  pageTitle: getPageViewId(state),
});

IBWConversion.defaultProps = {
  reportData: tracking.reportData,
};

export default connect(mapStateToProps)(IBWConversion);
